export default __webpack_public_path__ + "static/media/SJA1430.34I-42057_-25199_0.15197ee2.jpg";